import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import '../../../../assets/css/partials/PartsList.css'
import moment from 'moment'

function ContractorsList({ recentParts, loading }) {

    if (loading) {
        return <Skeleton height={60} count={6} />
    }

    if (recentParts.length === 0) {
        return (
            <div className="alert warning">
                {trans('messages.noDataFound')}
            </div>
        )
    }

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('tables.name')}</th>
                    <th>{trans('tables.type')}</th>
                    <th>{trans('tables.addedAt')}</th>
                </tr>
            </thead>

            <tbody>
                {recentParts.map((part, idx) => (
                    <tr key={part.id}>
                        <td>
                            {part.name}
                        </td>
                        <td>
                            <div className='action'>
                                {part.type_name}
                            </div>
                        </td>
                        <td>
                            {moment(part.date_added).format('DD.MM.YYYY / HH:mm')}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default ContractorsList